import React, { useEffect } from "react";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/RiskMembersSagas";
import { VIEWS } from "./redux/RiskMembersReducer";
import ViewFilter from "./smartComponents/ViewFilter";
import ZeroVisitsView from "./smartComponents/ZeroVisitsView";
import PredictionView from "./smartComponents/PredictionView";
import "./RiskMembersModule.css.scss";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import LearnMore from "../../../components/learnMore/learnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { useChaseIqAccess } from "../../../hooks/useChaseIqAccess";

const BY_VISITS_LEARN_MORE = {
  title: "At Risk Members",
  description:
    "This report identifies active members who may be at risk based on declining visit patterns or gaps in recent activity. These insights help you spot early signs of churn and take proactive steps to re‑engage members before they cancel.",
  kbUrl: ILEARN_URLS.membership.atRiskMembers
};

const RISK_FACTOR_DESCRIPTIONS = [
  ["Lapsed", "no recent attendance for an extended period"],
  ["Cancel Signal", "explicit cancellation indicator"],
  ["Recent Cancel Intent", "recent message or note suggesting intent to cancel"],
  ["Payment Stress", "declined payments, past-due balances or billing issues"],
  ["Low Engagement", "low visits / interactions relative to peers"],
  ["High Value / Low Engagement", "high-spend member whose engagement has dropped"],
  ["Attendance Gap", "break in visit cadence vs. their historical pattern"],
  ["New Member", "first 30–60 days, when retention risk is highest"]
];

const PredictionLearnMore = () => (
  <LearnMore
    title="At Risk Members — Risk Factors"
    content={
      <div>
        <p>
          Members are scored by ChaseIQ&apos;s churn model. The <strong>Risk Factors</strong> column
          surfaces the top two churn drivers per member. Possible factors:
        </p>
        <ul style={{ marginTop: 8, paddingLeft: 20 }}>
          {RISK_FACTOR_DESCRIPTIONS.map(([name, description]) => (
            <li key={name} style={{ marginBottom: 4 }}>
              <strong>{name}</strong> — {description}
            </li>
          ))}
        </ul>
      </div>
    }
  />
);

const RiskMembersModule = ({ ...rest }) => {
  const dispatch = useDispatch();
  const { isLoading, initialRequest, view } = useSelector((state) => state.riskMembers);

  const hasChaseIqAccess = useChaseIqAccess();

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser({ ...rest }));
    }
  }, []);

  const isByVisits = !hasChaseIqAccess || view === VIEWS.BY_VISITS;

  return (
    <div id="RiskMembers-root">
      <SectionToggle
        autoHeight
        learnMore={
          <>
            <ViewFilter />
            {isByVisits ? <KBLearnMore {...BY_VISITS_LEARN_MORE} /> : <PredictionLearnMore />}
          </>
        }
        title="At Risk Members"
        isLoading={isLoading}
        content={isByVisits ? <ZeroVisitsView /> : <PredictionView />}
      />
    </div>
  );
};

export default RiskMembersModule;
